.thirdPartyContainer {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 1.25rem;

	& .thirdPartyDesc {
		color: #333333;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
	}
}

.thirdPartyRow {
	display: flex;
	flex-direction: row;
	gap: 1.25rem;

	& > * {
		flex: 1;
	}

	& .platformSelect {
		height: 47px;
	}
}

.thirdPartyLabelWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.3125rem;
	max-width: 44%;

	& .titleRow {
		display: flex;
		flex-direction: row;
		gap: 0.3125rem;
		align-items: center;
	}
	& h3 {
		color: #333333;
		font-weight: 600;
		font-size: 0.875rem;
		line-height: 1.6;
	}
	& p,
	& span {
		color: #5e5e5e;
		font-weight: 400;
		line-height: 1.6;
		font-size: 0.875rem;
	}
}

.passwordContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
}

.noPasswordContainer {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 0.625rem;
	background-color: #f9f8ff;
	border: 1px solid #c0b9ec;
	border-radius: 10px;
	padding: 0.625rem;

	& span {
		color: #333333;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
	}
}

.selectLabelWrapper {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	height: 47px;

	& span {
		color: #4d4d4d;
		font-size: 0.875rem;
		font-weight: 400;
		line-height: 1.6;
	}

	& svg {
		height: 24px;
	}
}

@media (max-width: 768px) {
	.thirdPartyContainer {
		padding: 0.5rem;
		gap: 0.5rem;
		box-sizing: border-box;

		.thirdPartyRow {
			flex-direction: column;
			flex: unset;
			gap: 0.5rem;

			& .platformSelect {
				max-width: 100%;
				min-width: unset;
			}
		}
	}

	.noPasswordContainer {
		flex-direction: column;
		align-items: center;
	}
}

/** DELETE AFTER NEW THIRD PARTY WORKFLOW */

.urlValidationContainer {
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin-left: 2px;

	.validationRow {
		display: flex;
		align-items: center;
		margin-bottom: 5px;
		gap: 5px;

		img {
			height: 13.5px;
			object-fit: contain;
		}

		span {
			font-size: 15px;
		}
	}
}

.thirdPartyUrlControlContainer {
	display: flex;
	flex-direction: column;
	gap: 10px;
	flex: 1;
}

.urlValidationText:global(.MuiTypography-root) {
	color: #5e5e5e;
	font-size: 0.9375rem;
	line-height: 12px;
	font-weight: 400;
}

div.requiredRow {
	display: flex;
	flex-direction: row;
	gap: 4px;
	align-items: center;

	span {
		z-index: 0;
	}
}
